import React from "react";

const Landing = () => {
  return <h1>Landing</h1>;
};

export default Landing;
